import { Component, EventEmitter, Output } from '@angular/core';

export interface DateRange {
  fechaDesde: string | null;
  fechaHasta: string | null;
}

@Component({
  selector: 'app-date-range-filter',
  templateUrl: './date-range-filter.component.html',
  styleUrls: ['./date-range-filter.component.scss']
})
export class DateRangeFilterComponent {
  @Output() rangeChange = new EventEmitter<DateRange>();

  fechaDesde: Date | null = null;
  fechaHasta: Date | null = null;

  onPickerChange(): void {
    if (this.fechaDesde && this.fechaHasta && this.fechaHasta < this.fechaDesde) {
      const tmp = this.fechaDesde;
      this.fechaDesde = this.fechaHasta;
      this.fechaHasta = tmp;
    }
    this.emit();
  }

  presetHoy(): void {
    const today = this.startOfDay(new Date());
    this.fechaDesde = today;
    this.fechaHasta = today;
    this.emit();
  }

  presetUltimos7Dias(): void {
    const today = this.startOfDay(new Date());
    const desde = new Date(today);
    desde.setDate(desde.getDate() - 6);
    this.fechaDesde = desde;
    this.fechaHasta = today;
    this.emit();
  }

  presetEsteMes(): void {
    const today = this.startOfDay(new Date());
    this.fechaDesde = new Date(today.getFullYear(), today.getMonth(), 1);
    this.fechaHasta = today;
    this.emit();
  }

  presetMesAnterior(): void {
    const today = this.startOfDay(new Date());
    const firstThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastPrevMonth = new Date(firstThisMonth);
    lastPrevMonth.setDate(lastPrevMonth.getDate() - 1);
    const firstPrevMonth = new Date(lastPrevMonth.getFullYear(), lastPrevMonth.getMonth(), 1);
    this.fechaDesde = firstPrevMonth;
    this.fechaHasta = lastPrevMonth;
    this.emit();
  }

  limpiar(): void {
    this.fechaDesde = null;
    this.fechaHasta = null;
    this.emit();
  }

  private startOfDay(d: Date): Date {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  private toIsoDate(d: Date | null): string | null {
    if (!d) { return null; }
    const yyyy = d.getFullYear();
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return `${yyyy}-${mm}-${dd}`;
  }

  private emit(): void {
    this.rangeChange.emit({
      fechaDesde: this.toIsoDate(this.fechaDesde),
      fechaHasta: this.toIsoDate(this.fechaHasta)
    });
  }
}
